/* jslint esnext: true */

import IntlMessageFormat from './core';
import defaultLocale from './en';

IntlMessageFormat.__addLocaleData(defaultLocale);
IntlMessageFormat.defaultLocale = 'en';

export default IntlMessageFormat;



//////////////////
// WEBPACK FOOTER
// ./node_modules/intl-messageformat/src/main.js
// module id = null
// module chunks = 